export const version = '0.1.18-rc.0';
export const buildDate = '2025-01-14T14:41:43.342Z';
export const commitHash = 'ea2370f';